module.exports = __webpack_public_path__ + "static/img/icon.ac180da3.png";